<template>
  <div class="pt-10 pb-5 component-div">
    <b-row>
      <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
        <div class="number-sequence" :class="isFieldDisabled ? 'disable-question' : ''">
          <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
          <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
        </div>
        <span
          class="ml-2 question-tital-name"
          :class="isFieldDisabled ? 'disable-question' : ''"
          v-translate:_formattedBody="{
            key: translationKeyInitial,
            val: lang,
            html: componentData.formattedBody
          }"
          v-html="componentData.formattedBody"
        ></span>
        <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isFieldDisabled ? 'disable-question' : ''" v-translate:_optional="{ key: 'label', val: lang, html: 'Optional' }" v-if="componentData.isSkippable">Optional</span>
        <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
          Skipped
        </div>
        <div class="ml-5" v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon">
          <img alt="Bell icon" src="@/assets/NotificaionIcon.png" data-v-c76994f4 />
        </div>
        <span class="text-danger pl-5 fw-bold" v-if="hasFieldError">{{ fieldErrorText }}</span>
        <span class="text-warning pl-5 fw-bold" v-else-if="hasFieldWarning"> {{ fieldWarningText }}</span>
      </b-col>
    </b-row>

    <!-- PREVIEW MODE -->
    <template v-if="mode == 0">
      <b-row class="pl-30">
        <b-col cols="2">
          <b-form-input type="text" name="activityFormNumberPreview" disabled @input="onFieldChange" @keydown="isNumber($event, componentData)" size="sm" />
        </b-col>
        <b-col cols="1" class="p-0">
          <div class="pt-5" v-if="componentData.hasUnits">
            {{ componentData.units }}
          </div>
        </b-col>
        <b-col cols="8"></b-col>
      </b-row>
    </template>

    <!-- EDIT MODE -->
    <template v-else-if="mode == 1">
      <b-row class="pl-30" :class="isFieldDisabled ? 'disable-question' : ''">
        <b-col cols="2">
          <input class="mb-13 mb-5 form-control form-control-sm" type="text" name="activityFormNumberPreview" v-model="componentData.answer" :disabled="isFieldDisabled" v-on:change="onFieldChange" @keydown="isNumber($event, componentData)" :class="{ 'is-danger': hasFieldError }" size="sm" title="" />
        </b-col>
        <b-col cols="1" class="p-0" v-if="componentData.hasUnits">
          <div class="pt-5">
            {{ componentData.units }}
          </div>
        </b-col>
        <b-col cols="9"></b-col>
        <div>
          <span class="activity-form__clear ml-16" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
          <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
            <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }" class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              <span v-if="!componentData.answer">{{ showScore(componentData.skipScore) || 0 }}</span>
              <span v-else>{{ componentData.actualScore || 0 }}</span>
            </div>
          </div>
        </div>
        <b-col cols="8"></b-col>
      </b-row>
    </template>

    <!-- RESPONSE MODE -->
    <template v-else-if="mode == 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col :class="componentData.isEditedVersion ? 'col-6' : 'col-10'" class="pl-30">
          <span class="changed" v-if="componentData.isEditedVersion"></span>
          <div class="answers ml-16">{{ componentData.answer }}</div>
          <b-row class="pt-5">
            <div class="d-inline-block ml-16" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.actualScore) || showScore(componentData.skipScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer">
          <span class="previous-value-mark"></span>
          <div
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
            class="answers previous-value"
          >
            Previous value
          </div>
          <div>{{ componentData.previousAnswer }}</div>
          <b-row class="pt-5" v-if="componentData.previousAnswer">
            <div class="d-inline-block" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.previousActualScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";

export default {
  name: "activity-form-number-preview",

  mixins: [langTranslate],

  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: ""
    };
  },

  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      type: Boolean,
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {}
    },
    triggerValidate: {
      type: Boolean,
      default: false
    },
    isNotificationIcon: Boolean,
    isClearData: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    isFieldDisabled(val) {
      if (val === true) {
        this.resetField();
      }
    },
    hasFieldError(val) {
      this.componentData.hasFieldError = val;
    },
    fieldErrorText(val) {
      this.componentData.fieldErrorText = val;
    },
    triggerValidate() {
      if (!this.isFieldDisabled) {
        this.checkForFieldErrors();
      }
    },
    isClearData: {
      deep: true,
      handler(val) {
        if (val === true) {
          this.clearAnswer();
        }
      }
    }
  },

  mounted: function() {
    if (this.mode == 1) {
      this.$emit("initAnswerChange", this.componentData);
    }
    if (this.mode == 0 || this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.actualScore = this.componentData.skipScore;
        this.componentData.computedScore = this.componentData.skipScore;
      }
    }
    if (this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.previousActualScore = this.componentData.skipScore;
      }
    }
  },
  methods: {
    isNumber(e, componentData) {
      if (componentData.allowDecimals && componentData.allowNegative) {
        if (isNaN(e.key) && e.key !== "." && e.key !== "-" && e.key !== "Backspace" && e.key !== "ArrowRight" && e.key !== "ArrowLeft" && e.key !== "Tab") {
          e.preventDefault();
        }
        if (e.target.value.indexOf("-") >= 0 && e.key == "-") {
          e.preventDefault();
        } else if (e.target.value.indexOf(".") >= 0 && e.key == ".") {
          e.preventDefault();
        }
      } else if (componentData.allowDecimals) {
        if (isNaN(e.key) && e.key !== "." && e.key !== "Backspace" && e.key !== "ArrowRight" && e.key !== "ArrowLeft" && e.key !== "Tab") {
          e.preventDefault();
        }
        if (e.target.value.indexOf(".") >= 0 && e.key == ".") {
          e.preventDefault();
        }
      } else if (componentData.allowNegative) {
        if (isNaN(e.key) && e.key !== "-" && e.key !== "Backspace" && e.key !== "ArrowRight" && e.key !== "ArrowLeft" && e.key !== "Tab") {
          e.preventDefault();
        }
        if (e.target.value.indexOf("-") >= 0 && e.key == "-") {
          e.preventDefault();
        }
      } else if (isNaN(e.key) && e.key !== "Backspace" && e.key !== "ArrowRight" && e.key !== "ArrowLeft" && e.key !== "Tab") {
        e.preventDefault();
      }
    },
    showScore(score) {
      if (score) {
        return score;
      }
      return 0;
    },
    onFieldChange() {
      this.checkForFieldErrors();
      this.onAnswerChange();
    },
    resetField() {
      this.componentData.answer = undefined;
      this.componentData.dataChecks = [];

      setTimeout(() => {
        this.componentData.computedScore = 0;
        this.componentData.actualScore = 0;
      }, 10);
      this.resetAllErrors();
      this.$emit(`getQuestionScores`);
    },
    clearAnswer() {
      this.resetField();
      this.$emit("onClearAnswer", this.componentData);
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.componentData.computedScore = Number(this.componentData.answer);
        this.componentData.actualScore = Number(this.componentData.answer);
        this.componentData.dataChecks = this.componentData.dataChecks;
        this.$emit("onAnswerChange", this.componentData);
      });
    },

    //VALIDATIONS

    // Validation functions will return true if any errors and false if no errors

    validateMinMaxErrors(answer, minValue, maxValue, hasSoftMinMax, softminValue, softmaxValue, validateAnswerValue) {
      if (answer < minValue) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_number_min_of", `Answer should have a min of ${minValue}`, { MIN_NUM: minValue });
        if (hasSoftMinMax) {
          if (answer > softminValue) {
            this.hasFieldError = false;
            this.hasFieldWarning = true;
            this.fieldErrorText = "";
            this.fieldWarningText = this.translateToActiveLang("validation_error_number_soft_min", `This value is less than min (${minValue}) but greater than soft min (${softminValue})`, { MIN_NUM: minValue, SOFT_MIN_NUM: softminValue });
            return false;
          }
        }
        return true;
      }

      if (answer > maxValue) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_number_max_of", `Answer should have a max of ${maxValue}`, { MAX_NUM: maxValue });
        if (answer < softmaxValue) {
          this.hasFieldError = false;
          this.hasFieldWarning = true;
          this.fieldErrorText = "";
          this.fieldWarningText = this.translateToActiveLang("validation_error_number_soft_max", `This value is greater than max (${maxValue}) but less than soft max (${softmaxValue})`, { MAX_NUM: maxValue, SOFT_MAX_NUM: softmaxValue });
        }
        return true;
      }
      if (minValue.toString() != "-0" && validateAnswerValue == "-0") {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_number_min_of", `Answer should have a min of ${minValue}`, { MIN_NUM: minValue });
        return true;
      }

      return false;
    },

    validateAllowDecimals(answerOld, allowDecimals, decimalValue) {
      let answer = answerOld;
      if (allowDecimals) {
        const charCode = answer.toString();
        if (charCode.includes(".")) {
          const numb = charCode.split(".")[1];
          if (numb != null && numb.length > decimalValue) {
            this.hasFieldError = true;
            this.fieldErrorText = `Up to ${decimalValue} decimals are allowed.`;
            return true;
          }
        }
      }
      if (allowDecimals) {
        return false;
      }
      answer = Number(answer);
      if (!allowDecimals && this.getNumberCount(answer).length <= 306 && !Number.isInteger(answer)) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_decimal_not_allow", `Decimals not allowed`);
        return true;
      }
    },

    validateAllowNegativeValues(answer, allowNegative) {
      if (allowNegative) {
        return false;
      }
      if (answer < 0) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_negative_number", `Negative value not allowed`);
        return true;
      }
    },

    validateIsValidNumber(answer) {
      if (isNaN(Number(answer))) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_valid_number", `Answer should be a valid number`);
        return true;
      }
      return false;
    },

    validateIsRequired(answer) {
      if (answer === "" || answer == undefined) {
        this.hasFieldError = true;
        this.fieldErrorText = `Answer is required. Please fill`;
        return true;
      }
      return false;
    },

    resetAllErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = "";
    },

    checkForFieldErrors() {
      let { answer, minValue, maxValue, hasMinMax, hasSoftMinMax, allowDecimals, allowNegative, softminValue, softmaxValue, isSkippable, dataEditChecks, decimalValue, characterLimited, textLimit } = this.componentData;
      this.componentData.dataChecks = [];
      this.resetAllErrors();

      if (dataEditChecks) {
        let softDataCheck = false;
        for (let k = 0; k < dataEditChecks.length; k++) {
          if (dataEditChecks[k].check == "SOFT") {
            if (dataEditChecks[k].type == "DATA_FORMAT") {
              if (!Number.isInteger(Number(dataEditChecks[k].value))) {
                allowDecimals = true;
                let validateDecimal = this.regulateDecimal(answer, dataEditChecks[k].value);
                if (!validateDecimal) {
                  let message = this.convertMessage(dataEditChecks[k].value);
                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is not in the expected format: ${message}. Please review your response.`;
                  this.componentData.dataChecks.push({
                    dataCheckId: dataEditChecks[k].id,
                    dataCheckType: dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              } else if (Number.isInteger(Number(dataEditChecks[k].value))) {
                let validateDecimal = this.regulateDecimal(answer, dataEditChecks[k].value);
                if (!validateDecimal) {
                  let message = this.convertMessage(dataEditChecks[k].value);
                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is not in the expected format: ${message}. Please review your response.`;
                  this.componentData.dataChecks.push({
                    dataCheckId: dataEditChecks[k].id,
                    dataCheckType: dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              }
            }
          } else {
            if (dataEditChecks[k].type == "DATA_FORMAT") {
              if (!Number.isInteger(Number(dataEditChecks[k].value))) {
                allowDecimals = true;
                let validateDecimal = this.regulateDecimal(answer, dataEditChecks[k].value);
                if (!validateDecimal) {
                  let message = this.convertMessage(dataEditChecks[k].value);
                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response using format: ${message}.`;
                  isSkippable = false;
                }
              } else if (Number.isInteger(Number(dataEditChecks[k].value))) {
                let validateDecimal = this.regulateDecimal(answer, dataEditChecks[k].value);
                if (!validateDecimal) {
                  let message = this.convertMessage(dataEditChecks[k].value);
                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response using format: ${message}.`;
                  isSkippable = false;
                }
              }
            }
          }
        }

        if (softDataCheck) {
          return false;
        }
      }
      if ((isSkippable && !answer) || this.isFieldDisabled) {
        return;
      }

      if (!isSkippable && !answer) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_required", `This field is required.`);
        return;
      }

      if (!this.hasFieldError) {
        if (this.validateIsValidNumber(answer)) {
          return;
        }

        const validateAnswerValue = answer;
        answer = Number(answer);

        if (hasMinMax) {
          if (this.validateMinMaxErrors(answer, minValue, maxValue, hasSoftMinMax, softminValue, softmaxValue, validateAnswerValue)) {
            return;
          }
        }

        if (this.validateAllowDecimals(validateAnswerValue, allowDecimals, decimalValue)) {
          return;
        }

        if (this.validateAllowNegativeValues(answer, allowNegative)) {
          return;
        }

        this.hasFieldError = false;
      }
      if (this.validateNumberLimit(answer, characterLimited, textLimit)) {
        return;
      }
    },
    validateNumberLimit(answerOld, characterLimited, textLimit) {
      let answer = answerOld;
      const getNumberCount = this.getNumberCount(answer).length;
      answer = answer.toString();
      if (characterLimited && getNumberCount > textLimit) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_char_limit", `Number limit can not be more than ${textLimit}.`, { CHAR_LIMIT: textLimit });
        return true;
      }
      if (characterLimited == false && getNumberCount > 4096) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_char_limit", `Number limit can not be more than 4096.`, { CHAR_LIMIT: 4096 });
        return true;
      }
      return false;
    },
    regulateDecimal(answer, decimal) {
      if (decimal.includes(".") && answer.includes(".")) {
        const decimalValue = decimal.split(".");
        const answerValue = answer.split(".");
        if (answerValue[0].replace(/\s/g, "").length > decimalValue[0] || !answerValue[0].trim().length) {
          return false;
        }
        if (answerValue[1].replace(/\s/g, "").length > decimalValue[1] || !answerValue[1].trim().length) {
          return false;
        }
      } else if (decimal.includes(".")) {
        return false;
      } else if (!!answer && !!decimal && answer.length > decimal) {
        return false;
      }

      return true;
    },
    convertMessage(number) {
      let stringMessage = "";

      if (number.includes(".")) {
        const numberValue = number.split(".");
        for (let i = 1; i <= numberValue[0]; i++) {
          stringMessage += "x";
        }
        stringMessage += ".";
        for (let i = 1; i <= numberValue[1]; i++) {
          stringMessage += "y";
        }
      } else {
        for (let i = 1; i <= number; i++) {
          stringMessage += "x";
        }
      }

      return stringMessage;
    },
    getNumberCount(num) {
      const onlyDigit = Number(String(num).replace(/[^0-9]/g, ""));
      return onlyDigit.toString();
      /* return (''+ +num).replace(/(-?)(\d*)\.?(\d*)e([+-]\d+)/,
      function(a,b,c,d,e) {
        return e < 0
          ? b + '0.' + Array(1-e-c.length).join(0) + c + d
          : b + c + d + Array(e-d.length+1).join(0);
      }); */
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
}

.previous-answer {
  opacity: 0.8;
}

.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}
.activity-form__clear {
  width: 29px;
  height: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c8ce4;
}
.number-sequence {
  min-width: 30px;
  display: inline-block;
}
.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}
.cursor_pointer1 {
  cursor: pointer;
  width: 22px;
  height: 20px;
  border-radius: 4px;
  background-color: #c4c4c4;
  display: inline-block;
  color: #fff;
  text-align: center;
}

@media (min-width: 320px) and (max-width: 768px) {
  .col-2 {
    flex: 0 0 24.999999%;
    max-width: 24.999999%;
  }
  .col-9 {
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }
}
.clearOptionDisabled {
  pointer-events: none !important;
}
</style>
